'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(el) {
  (0, _classCallCheck3.default)(this, Header);

  var setHdPosition = function setHdPosition() {
    var previousScrollAmount = 0;
    var content = (0, _functional.getElement)('body');

    document.addEventListener('scroll', function (e) {
      var hd = (0, _functional.getElement)('.lyt-Header-unsticky');
      var toggleAnnouncementBar = (0, _functional.getElement)('.lyt-HeaderAnnouncement-toggle');
      var scrolled = window.pageYOffset;
      var position = content.offsetTop;

      if (hd) {
        if (scrolled > position) {
          content.classList.add('lyt-Body-active');
          hd.classList.add('lyt-Header-active');
          hd.classList.add('lyt-HeaderAnnouncement-active');
        } else {
          content.classList.remove('lyt-Body-active');
          hd.classList.remove('lyt-Header-active');
          hd.classList.remove('lyt-HeaderAnnouncement-active');
        }

        if (toggleAnnouncementBar) {
          hd.classList.toggle('lyt-Header-scrollingUp', scrolled < previousScrollAmount);
        }
        content.classList.toggle('lyt-Body-scrollingUp', scrolled < previousScrollAmount);

        // show again if at the top
        if (scrolled === 0) {
          hd.classList.remove('lyt-HeaderAnnouncement-active');
        }
      }

      previousScrollAmount = scrolled;
    });
  };

  setTimeout(function () {
    setHdPosition();
  }, 300);

  window.onresize = function (e) {
    setHdPosition();
  };

  var headerAnnouncementBar = (0, _functional.getElement)('.js-Header_AnnouncementBar');

  document.querySelector(':root').style.setProperty('--Announcement_Height', headerAnnouncementBar.offsetHeight + 'px');

  var headerAnnouncementBarText = (0, _functional.getElement)('[data-header-announcement-bar-text]');

  var swappableTextEl = (0, _functional.getElement)('[data-header-swappable-text-enabled]');

  var swappableTextContent = (0, _functional.getElement)('[data-header-swappable-text-content]');

  if (swappableTextEl) {
    swappableTextEl.addEventListener('click', function () {
      headerAnnouncementBarText.innerHTML = swappableTextContent.innerHTML;
    });
  }
};

exports.default = Header;